export enum IODirection {
    Input,
    Output,
}
